import React, { FC } from 'react'
import { t, Trans } from '@lingui/macro'
import { notification } from '../../../../components/common/notifications/Notifications'
import {
  Box,
  ButtonDanger,
  ButtonLight,
  Modal,
  Text
} from 'front-end/src/components'
import { ResourceRelatedInstances } from '../../../manage-workspace-page/delete-resource-modal/ResourceRelatedInstances'
import { useTopicRelatedInstancesQuery } from '../../../manage-workspace-page/delete-resource-modal/DeleteResourceModal.codegen'
import { useParams } from 'react-router-dom'

type Props = {
  resolve: () => void
  reject: () => void
}

export const ResourceUnpublishModal: FC<Props> = ({ resolve, reject }) => {
  const params = useParams<{
    topicId: string
  }>()
  const { data } = useTopicRelatedInstancesQuery({
    variables: { topicId: Number(params.topicId) }
  })

  if (!data?.topic || data.topic.__typename !== 'TopicModelAsEditor') {
    return null
  }
  const { topic } = data

  const relatedInstancesCount =
    topic?.relatedCampaignsByActions.length +
    topic?.relatedCampaignsByFilters.length +
    topic?.relatedCertifications.length +
    topic?.relatedPathways.length

  return (
    <Modal
      newDesign
      className={'ModalUnpublishResource'}
      header={t`Are you sure you want to return this resource to draft? `}
      controls={
        <Box>
          <ButtonLight onClick={reject}>
            <Trans>Cancel</Trans>
          </ButtonLight>

          <ButtonDanger
            onClickAsync={async () => {
              try {
                resolve()
                notification.info(t`Resource successfully returned to draft.`)
              } catch (e) {
                notification.error(
                  t`Error while unpublishing resource, please try again later.`
                )
              }
            }}
          >
            <Trans>Return to draft</Trans>
          </ButtonDanger>
        </Box>
      }
      onHide={reject}
    >
      {relatedInstancesCount > 0 && (
        <>
          <Text pb="8px">
            <Trans>This resource appears in the following instances.</Trans>
          </Text>
          <ResourceRelatedInstances topic={topic} />
        </>
      )}
    </Modal>
  )
}
